<template>
	<li
		class="c-multi-level-menu__item"
		:class="{ 'c-multi-level-menu__item-primary': isPrimaryMenuItem }"
	>
		<button
			v-if="menuItem.HasSubMenuItems"
			tabindex="0"
			class="c-multi-level-menu__subitem"
			:title="menuItem.Title"
			type="button"
			:class="{
				'c-multi-level-menu__subitem--open': !isPrimaryMenuItem && menuItem.isOpen,
				'c-multi-level-menu__subitem-primary': isPrimaryMenuItem,
				'c-multi-level-menu__subitem-primary--open': isPrimaryMenuItem && menuItem.isOpen,
				'c-multi-level-menu__subitem--selected': isPrimaryMenuItem && menuItem.Selected,
			}"
			@click="$emit('toggle-menu-lists')"				
		    @mouseover="$emit('clear-lists')"
		>
			{{ menuItem.LinkText }}
		</button>
		<a
			v-if="!menuItem.HasSubMenuItems && menuItem.LinkUrl"
			tabindex="0"
			:title="menuItem.Title"
			:href="menuItem.LinkUrl"
			class="c-multi-level-menu__link"
		>
			{{ menuItem.LinkText }}
		</a>
		<slot></slot>
	</li>
</template>

<script>
	export default {
		name: 'multi-level-menu-item',
		props: {
			menuItem: Object,
			isPrimaryMenuItem: Boolean,
		},
		emits: ['toggle-menu-lists', 'clear-lists'],
	};
</script>
